/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


window.addEventListener('load', function() {
  const elementToRemove = document.getElementById('track123-powered-by');
  if (elementToRemove !== null) {
    elementToRemove.remove();
    // oder alternativ: elementToRemove.parentNode.removeChild(elementToRemove);
  }
});

function countdown(element, minutes, seconds) {
// set time for the particular countdown
var time = minutes*60 + seconds;

var checkClassInterval = setInterval(function() {
if (document.getElementsByClassName("line-item__content-wrapper").length > 0) {
clearInterval(checkClassInterval);
var interval = setInterval(function() {
var el = document.getElementById(element);
// if the time is 0 then end the counter
if (time <= 0) {
var text = "<b>Order Now</b>";
var ef = document.getElementsByClassName('notch')[0];
if(ef) ef.innerHTML = text;
clearInterval(interval);
return;
}
var minutes = Math.floor( time / 60 );
if (minutes < 10) minutes = "0" + minutes;
var seconds = time % 60;
if (seconds < 10) seconds = "0" + seconds;
var text = minutes + ':' + seconds;
if(el) el.innerHTML = text;
time--;
}, 1000);
}
}, 1000);
}

document.addEventListener('DOMContentLoaded', () => {
  countdown('clock', 10, 0);
  var count = document.getElementById('cart__count');
  var counttext = 1;
  if (count) {
    count.innerHTML = counttext;
  }
});

/* shipping protection */
(function() {
  const VARIANT_ID = '47904914473125';
  const COOKIE_NAME = 'sp_pref';
  const UPDATE_DELAY = 300;
  const RETRY_DELAY = 100;
  const DUPLICATE_REMOVE_DELAY = 200;
  const REFRESH_CHECK_DELAY = 50;
  const HANDLER_ATTACH_DELAY = 100;
  const STATE_CHECK_INTERVAL = 800;
  const INITIAL_FORCE_DELAY = 500;
  
  let isUpdating = false;
  let currentState = null;

  function setCookie(name, value, days = 365) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/;SameSite=Lax`;
    console.log('💾 Cookie:', value);
  }

  function getCookie(name) {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(nameEQ)) {
        return cookie.substring(nameEQ.length);
      }
    }
    return null;
  }

  function getCorrectState() {
    if (currentState !== null) return currentState;
    
    const savedPref = getCookie(COOKIE_NAME);
    
    if (savedPref === null) {
      console.log('📝 First visit - default TRUE');
      currentState = true;
      setCookie(COOKIE_NAME, 'true');
      return true;
    }
    
    currentState = savedPref === 'true';
    return currentState;
  }

  function updateState(newState) {
    currentState = newState;
    setCookie(COOKIE_NAME, newState);
  }

  function updateToggleUI(state) {
    const toggle = document.getElementById('sp-custom-toggle');
    if (!toggle) return;
    
    toggle.setAttribute('data-checked', state);
    toggle.style.backgroundColor = state ? '#4CAF50' : '#ccc';
    
    const slider = toggle.querySelector('.sp-custom-slider');
    if (slider) {
      slider.style.transform = state ? 'translateX(24px)' : 'translateX(0px)';
    }
  }

  function isProtectionItem(item) {
    return String(item.variant_id) === VARIANT_ID || 
           String(item.id) === VARIANT_ID ||
           (item.title && item.title.toLowerCase().includes('versand'));
  }

  function finishUpdating() {
    setTimeout(() => { isUpdating = false; }, UPDATE_DELAY);
  }

  function forceToggleState() {
    updateToggleUI(getCorrectState());
  }

  function removeAllProtections() {
    console.log('🗑️ Removing...');
    isUpdating = true;
    
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const protectionItems = cart.items.filter(isProtectionItem);
        
        if (protectionItems.length === 0) {
          isUpdating = false;
          return;
        }
        
        return Promise.all(
          protectionItems.map(item => 
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            })
          )
        );
      })
      .then(finishUpdating)
      .catch(e => {
        console.error('❌ Error:', e);
        finishUpdating();
      });
  }

  function addProtection() {
    isUpdating = true;
    
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const existingProtections = cart.items.filter(isProtectionItem);
        
        if (existingProtections.length > 0) {
          return Promise.all(
            existingProtections.map(item => 
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 0 })
              })
            )
          ).then(() => new Promise(resolve => setTimeout(resolve, DUPLICATE_REMOVE_DELAY)));
        }
      })
      .then(() => 
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: VARIANT_ID, quantity: 1 })
        })
      )
      .then(r => {
        if (!r.ok) {
          return r.text().then(text => {
            console.error('Add failed:', text);
            throw new Error('Add failed');
          });
        }
        return r.json();
      })
      .then(finishUpdating)
      .catch(e => {
        console.error('❌ Error:', e);
        finishUpdating();
      });
  }

  function handleToggleClick(e) {
    e?.preventDefault();
    e?.stopPropagation();
    
    if (isUpdating) {
      return;
    }
    
    const toggle = document.getElementById('sp-custom-toggle');
    if (!toggle) return;
    
    const current = toggle.getAttribute('data-checked') === 'true';
    const newState = !current;
    
    updateState(newState);
    updateToggleUI(newState);
    
    newState ? addProtection() : removeAllProtections();
  }

  function attachClickHandler() {
    const toggle = document.getElementById('sp-custom-toggle');
    if (!toggle) {
      setTimeout(attachClickHandler, RETRY_DELAY);
      return;
    }
    
    toggle.removeEventListener('click', handleToggleClick);
    toggle.removeEventListener('touchend', handleToggleClick);
    toggle.addEventListener('click', handleToggleClick, false);
    toggle.addEventListener('touchend', handleToggleClick, false);
  }

  // Cart refresh listeners
  ['cart:refresh', 'cart:updated', 'cart:update', 'cart-drawer:refresh'].forEach(eventName => {
    document.addEventListener(eventName, () => {
      if (!isUpdating) {
        setTimeout(forceToggleState, REFRESH_CHECK_DELAY);
        setTimeout(attachClickHandler, HANDLER_ATTACH_DELAY);
      }
    });
  });

  // State monitoring
  setInterval(() => {
    if (isUpdating) return;
    
    const toggle = document.getElementById('sp-custom-toggle');
    if (!toggle) return;
    
    const currentAttr = toggle.getAttribute('data-checked');
    const shouldBe = String(getCorrectState());
    
    if (currentAttr !== shouldBe) {
      forceToggleState();
    }
    
    if (!toggle.onclick && !toggle.hasAttribute('data-handler-attached')) {
      attachClickHandler();
    }
  }, STATE_CHECK_INTERVAL);

  function initToggle() {
    
    const toggle = document.getElementById('sp-custom-toggle');
    
    if (!toggle) {
      setTimeout(initToggle, RETRY_DELAY);
      return;
    }
    
    const shouldBeChecked = getCorrectState();
    
    forceToggleState();
    attachClickHandler();
    
    setTimeout(forceToggleState, INITIAL_FORCE_DELAY);
    
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const isInCart = cart.items.filter(isProtectionItem).length > 0;
        
        if (shouldBeChecked && !isInCart) {
          addProtection();
        } else if (!shouldBeChecked && isInCart) {
          removeAllProtections();
        }
        
      })
      .catch(e => console.error('❌ Error:', e));
  }

  initToggle();
})();